<template>
  <div
    v-if="cargando"
    class="position-absolute top-50 start-50 translate-middle"
  >
    <fade-loader
      :loading="cargando"
      :color="'#302D74'"
      :height="'25px'"
      :width="'5px'"
    ></fade-loader>
  </div>
  <div v-if="!cargando" class="row">
    <div class="col-12 col-md-12 col-lg-2">
      <navegacion-lateral
        :seleccionA="seleccionadoA"
        :seleccionB="seleccionadoB"
        :seleccionC="seleccionadoC"
        :seleccionD="seleccionadoD"
        :remarcadoA="subrayadoA"
        :remarcadoB="subrayadoB"
        :remarcadoC="subrayadoC"
        :remarcadoD="subrayadoD"
      >
      </navegacion-lateral>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-10">
      <navegacion-superior
        :mostrarRetorno="mostrarRetorno"
      ></navegacion-superior>
      <div id="Tablero" class="container mt-3">
        <div class="row mb-4 mt-3">
          <div class="col-sm-12 col-md-5">
            <h2
              class="text-start mb-3"
              v-if="operacion.enumEstatusOperacion == 1"
            >
              En proceso
            </h2>
            <h2
              class="text-start mb-3"
              v-else-if="operacion.enumEstatusOperacion == 2"
            >
              En resolución
            </h2>
            <!-- <h2 class="text-start" v-else-if="$route.params.estatus == 3">Dictaminada</h2> -->
            <h2
              class="text-start mb-3"
              v-else-if="
                operacion.enumEstatusOperacion == 3 &&
                  operacion.resolucion == 'APROBADA'
              "
              style="color: #17AD61;"
            >
              <i class="bi bi-check-circle me-3" style="font-size: 3rem;"></i
              >APROBADA
            </h2>
            <h2
              class="text-start"
              v-else-if="
                operacion.enumEstatusOperacion == 3 &&
                  operacion.resolucion == 'RECHAZADA'
              "
              style="color: #FF7184;"
            >
              <i class="bi bi-x-circle me-3" style="font-size: 3rem;"></i
              >RECHAZADA
            </h2>
            <h2
              class="text-start"
              v-else-if="
                operacion.enumEstatusOperacion == 3 &&
                  operacion.resolucion == 'PENDIENTE'
              "
              style="color: #568FFE;"
            >
              <i class="bi bi-dash-circle me-3" style="font-size: 3rem;"></i
              >PENDIENTE
            </h2>
          </div>
          <div
            v-if="
              operacion.enumEstatusOperacion == 2 ||
                operacion.enumEstatusOperacion == 3
            "
            class="col-sm-12 col-md-7"
          >
            <div class="row justify-content-end">
              <div
                class="col-sm-12 col-md-4 mb-3 d-flex"
                v-if="
                  usuario.roles.includes('Secretario') &&
                    operacion.enumEstatusOperacion == 2
                "
              >
                <button
                  type="button"
                  class="btn btn-secondary rounded-pill w-100"
                  @click="ActualizarCandadoQuorum()"
                >
                  <i
                    :class="
                      `${
                        operacion.candadoQuorum
                          ? 'bi bi-lock ms-3'
                          : 'bi bi-unlock ms-3'
                      }`
                    "
                  ></i>
                  {{ operacion.candadoQuorum ? "Quórum" : "Sin Quórum" }}
                </button>
              </div>
              <div
                class="col-sm-12 col-md-4  mb-3  d-flex"
                v-if="
                  (usuario.roles.includes('Secretario') &&
                    operacion.enumEstatusOperacion == 2) ||
                    usuario.roles.includes('Secretario') ||
                    (usuario.puedeVotar && operacion.enumEstatusOperacion == 3)
                "
              >
                <button
                  type="button"
                  class="btn btn-secondary rounded-pill w-100"
                  data-bs-toggle="modal"
                  @click="
                    verResolucion();
                    ObtenerCatalogoCondicionantes();
                  "
                >
                  Ver resolución
                </button>
              </div>
              <div
                class="col-sm-12 col-md-4 mb-3  d-flex"
                v-if="usuario.puedeVotar && operacion.enumEstatusOperacion != 3"
              >
                <button
                  type="button"
                  class="btn btn-primary rounded-pill w-100"
                  @click="validarExistenciaVoto()"
                >
                  Votar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6 mt-7" style="width: 45%">
              <detalle-cliente :operacion="operacion"></detalle-cliente>
            </div>
            <div
              class="col-sm-12 col-md-6 col-lg-6 mt-7"
              style="width: 10%"
            ></div>
            <div
              class="col-sm-12 col-md-6 col-lg-6 mt-4 ml-8"
              style="width: 45%"
            >
              <label
                ><b>Tipo de producto | Plan: </b
                >{{ operacion.tipoProducto }}</label
              >
              <label
                ><b>Factor de actualización: </b
                >{{ operacion.factorActualizacion }}</label
              >
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12">
            <detalle-montos-operacion
              :operacion="operacion"
            ></detalle-montos-operacion>
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
                <detalle-condiciones-operacion
                  :operacion="operacion"
                ></detalle-condiciones-operacion>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6 mt-5">
                <detalle-pronunciamiento-operacion
                  :operacion="operacion"
                ></detalle-pronunciamiento-operacion>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <detalle-tablero-control
                  :operacion="operacion"
                  :totalContratos="totalContratos"
                  :integrante="integrante"
                  :adjudicatario="adjudicatario"
                  :adjudicado="adjudicado"
                  :total="total"
                  :scoreBuro="scoreBuro"
                ></detalle-tablero-control>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <detalle-escrituracion
                  :operacion="operacion"
                ></detalle-escrituracion>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-12">
                <detalle-credito :operacion="operacion"></detalle-credito>
              </div>
            </div>
            <div class="row mt-4 mb-5">
              <div class="col-md-12">
                <detalle-fondeo
                  :operacion="operacion"
                  :listaBeneficiarios="listaBeneficiarios"
                  :montoTotalBeneficiarios="montoTotalBeneficiarios"
                  :montoDisponibleDespFondear="montoDisponibleDespFondear"
                ></detalle-fondeo>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <modal-panel-votacion
    :operacion="operacion"
    :votoDto="votoDto"
  ></modal-panel-votacion>
  <modal-resolucion
    :operacion="operacion"
    :resultadoVotaciones="resultadoVotaciones"
    :catalogoCondicionantes="catalogoCondicionantes"
  ></modal-resolucion>
</template>
<script>
import { defineComponent } from "vue";
import NavegacionSuperior from "@/Aplicaciones/CCD/Componentes/NavegacionSuperior.vue";
import NavegacionLateral from "@/Aplicaciones/CCD/Componentes/NavegacionLateral.vue";
import FadeLoader from "vue-spinner/src/FadeLoader.vue";
import DetalleCliente from "@/Aplicaciones/CCD/Areas/CCD/Componentes/DetalleCliente.vue";
import DetalleMontosOperacion from "@/Aplicaciones/CCD/Areas/CCD/Componentes/DetalleMontosOperacion.vue";
import DetalleCondicionesOperacion from "@/Aplicaciones/CCD/Areas/CCD/Componentes/DetalleCondicionesOperacion.vue";
import DetallePronunciamientoOperacion from "@/Aplicaciones/CCD/Areas/CCD/Componentes/DetallePronunciamientoOperacion.vue";
import DetalleTableroControl from "@/Aplicaciones/CCD/Areas/CCD/Componentes/DetalleTableroControl.vue";
import DetalleEscrituracion from "@/Aplicaciones/CCD/Areas/CCD/Componentes/DetalleEscrituracion.vue";
import DetalleCredito from "@/Aplicaciones/CCD/Areas/CCD/Componentes/DetalleCredito.vue";
import DetalleFondeo from "@/Aplicaciones/CCD/Areas/CCD/Componentes/DetalleFondeo.vue";
import ModalPanelVotacion from "@/Aplicaciones/CCD/Areas/CCD/Componentes/ModalPanelVotacion.vue";
import ModalResolucion from "@/Aplicaciones/CCD/Areas/CCD/Componentes/ModalResolucion.vue";
import * as bootstrap from "bootstrap";

export default defineComponent({
  name: "Detalle de Operación",
  components: {
    NavegacionSuperior,
    NavegacionLateral,
    DetalleCliente,
    DetalleMontosOperacion,
    DetalleCondicionesOperacion,
    DetallePronunciamientoOperacion,
    DetalleTableroControl,
    DetalleEscrituracion,
    DetalleCredito,
    DetalleFondeo,
    FadeLoader,
    ModalPanelVotacion,
    ModalResolucion,
  },

  data() {
    return {
      cargando: false,
      respuesta: {},
      operacion: {},
      scoreBuro: null,
      mostrarRetorno: true,
      seleccionadoA: false,
      seleccionadoB: false,
      seleccionadoC: false,
      seleccionadoD: false,
      subrayadoA: "",
      subrayadoB: "",
      subrayadoC: "",
      subrayadoD: "",
      usuario: {},
      resultadoVotaciones: {},
      catalogoCondicionantes: [],
      listaBeneficiarios: null,
      montoTotalBeneficiarios: 0,
      montoDisponibleDespFondear: 0,
      voto: null,
      votoDto: {},
      //TipoDePonderados,
      totalContratos: 0,
      integrante: {
        integranteAnticipo: 0,
        integranteVencidas: 0,
        integrantePuntuales: 0,
        totalIntegrante: 0,
      },
      adjudicatario: {
        adjudicatarioAnticipo: 0,
        adjudicatarioVencidas: 0,
        adjudicatarioPuntuales: 0,
        totalAdjudicatario: 0,
      },
      adjudicado: {
        adjudicadoAnticipo: 0,
        adjudicadoVencidas: 0,
        adjudicadoPuntuales: 0,
        totalAdjudicado: 0,
      },
      total: {
        totalAnticipo: 0,
        totalVencidas: 0,
        totalPuntuales: 0,
        totalTotal: 0,
      },
    };
  },

  created() {
    this.validarSesion();
    this.mostrarRetorno = true;
    this.obtenerUsuarioSesion();
  },

  mounted() {
    if (this.$route.params.estatus == "1") {
      this.seleccionadoA = false;
      this.seleccionadoB = true;
      this.seleccionadoC = false;
      this.seleccionadoD = false;
      this.subrayadoA = "";
      this.subrayadoB = "text-decoration-underline";
      this.subrayadoC = "";
      this.subrayadoD = "";
    }
    if (this.$route.params.estatus == "2") {
      this.seleccionadoA = false;
      this.seleccionadoB = false;
      this.seleccionadoC = true;
      this.seleccionadoD = false;
      this.subrayadoA = "";
      this.subrayadoB = "";
      this.subrayadoC = "text-decoration-underline";
      this.subrayadoD = "";
    }
    if (this.$route.params.estatus == "3") {
      this.seleccionadoA = false;
      this.seleccionadoB = false;
      this.seleccionadoC = false;
      this.seleccionadoD = true;
      this.subrayadoA = "";
      this.subrayadoB = "";
      this.subrayadoC = "";
      this.subrayadoD = "text-decoration-underline";
    }
  },

  methods: {
    calcularIngresosTotales(ingresos) {
      let total = ingresos.reduce(function(accumulator, currentValue) {
        return accumulator + currentValue.montoIngreso;
      }, 0);
      return total;
    },

    obtenerMensajeError(error) {
      if (String(error).includes("401")) {
        this.$router.push({ name: "Login" });
        return "Error de autenticación, por favor ingresa tus credenciales";
      }
      if (error == "Error: Network Error") {
        return "Error de conexión";
      }
      return error;
    },

    async validarSesion() {
      await this.axios
        .post("Usuario/ValidarSesion")
        .then((response) => {
          this.respuesta = response.data;
          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            this.cargando = true;
            this.obtenerOperacion();
          }
          if (this.respuesta.estatusRespuesta != this.estatusRespuesta.OK) {
            this.$router.push({ name: "Login" });
            this.notificar({
              Estatus: this.estatusRespuesta.ERROR,
              Mensaje:
                "Error de autenticación, por favor ingresa tus credenciales",
            });
          }
        })
        .catch((error) => {
          this.notificar({
            Estatus: this.estatusRespuesta.ERROR,
            Mensaje: this.obtenerMensajeError(error),
          });
        });
    },

    async obtenerOperacion() {
      const id = this.$route.params.id;
      await this.axios
        .get(`Operacion/${id}`)
        .then((response) => {
          this.respuesta = response.data;
          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            this.operacion = this.respuesta.resultado;
            this.scoreBuro = this.operacion.clientes[0].consultaBuroCredito.scoreBuro;
            this.listaBeneficiarios = this.respuesta.resultado.beneficiarioOperacionConcepto;
            this.obtenerValoresGrafica();
            this.totalBeneficiarios();
          } else {
            this.notificar({
              Estatus: this.respuesta.estatusRespuesta,
              Mensaje: this.respuesta.mensaje,
            });
          }
        })
        .catch((error) => {
          this.notificar({
            Estatus: this.estatusRespuesta.ERROR,
            Mensaje: this.obtenerMensajeError(error),
          });
        })
        .finally(() => (this.cargando = false));
    },
    async totalBeneficiarios() {
      if (this.listaBeneficiarios) {
        this.listaBeneficiarios.map((element) => {
          this.montoTotalBeneficiarios += element.monto;
          this.montoDisponibleDespFondear =
            this.operacion.totalMontoAdjudicado - this.montoTotalBeneficiarios;
        });
      }
    },

    async obtenerValoresGrafica() {
      //Total Contratos
      this.totalContratos = this.operacion.totalContratos;

      //INTEGRANTE
      //ANTICIPOS
      this.integrante.integranteAnticipo = Number(
        Number.parseFloat(
          this.operacion.datosGrafica[0].promedioAnticipadasAntesAdj
        ).toFixed(1)
      );
      //VENCIDOS
      this.integrante.integranteVencidas = Number(
        Number.parseFloat(
          this.operacion.datosGrafica[0].promedioNoPuntualesAntesAdj
        ).toFixed(1)
      );
      //PUNTUALES
      this.integrante.integrantePuntuales = Number(
        Number.parseFloat(
          this.operacion.datosGrafica[0].promedioPuntualesAntesAdj
        ).toFixed(1)
      );
      //TOTAL INTEGRANTE
      this.integrante.totalIntegrante = Number(
        Number.parseFloat(
          Number(this.integrante.integranteAnticipo) +
            Number(this.integrante.integrantePuntuales) +
            Number(this.integrante.integranteVencidas)
        ).toFixed(1)
      );

      //ADJUDICATARIO
      //ANTICIPOS
      this.adjudicatario.adjudicatarioAnticipo = Number(
        Number.parseFloat(
          this.operacion.datosGrafica[0].promedioAnticipadasDespuesAdj
        ).toFixed(1)
      );
      //VENCIDOS
      this.adjudicatario.adjudicatarioVencidas = Number(
        Number.parseFloat(
          this.operacion.datosGrafica[0].promedioNoPuntualesDespuesAdj
        ).toFixed(1)
      );
      //PUNTUALES
      this.adjudicatario.adjudicatarioPuntuales = Number(
        Number.parseFloat(
          this.operacion.datosGrafica[0].promedioPuntualesDespuesAdj
        ).toFixed(1)
      );
      //TOTAL ADJUDICATARIO
      this.adjudicatario.totalAdjudicatario = Number.parseFloat(
        Number(this.adjudicatario.adjudicatarioAnticipo) +
          Number(this.adjudicatario.adjudicatarioPuntuales) +
          Number(this.adjudicatario.adjudicatarioVencidas)
      ).toFixed(1);

      //TOTAL
      this.total.totalAnticipo = Number(
        Number.parseFloat(
          Number(this.integrante.integranteAnticipo) +
            Number(this.adjudicatario.adjudicatarioAnticipo)
        ).toFixed(1)
      );
      this.total.totalVencidas = Number(
        Number.parseFloat(
          Number(this.integrante.integranteVencidas) +
            Number(this.adjudicatario.adjudicatarioVencidas)
        ).toFixed(1)
      );
      this.total.totalVencidasPromedio = Number(
        Number.parseFloat(
          Number(this.integrante.integranteVencidasPromedio) +
            Number(this.adjudicatario.adjudicatarioVencidasPromedio)
        ).toFixed(1)
      );
      this.total.totalPuntuales = Number(
        Number.parseFloat(
          Number(this.integrante.integrantePuntuales) +
            Number(this.adjudicatario.adjudicatarioPuntuales)
        ).toFixed(1)
      );
      this.total.totalPuntualesPromedio = Number(
        Number.parseFloat(
          Number(this.integrante.integrantePuntualesPromedio) +
            Number(this.adjudicatario.adjudicatarioPuntualesPromedio)
        ).toFixed(1)
      );

      //TOTAL TOTALES
      this.total.totalTotal = Number(
        Number.parseFloat(
          Number(this.total.totalAnticipo) +
            Number(this.total.totalPuntuales) +
            Number(this.total.totalVencidas)
        ).toFixed(1)
      );
    },
    async obtenerUsuarioSesion() {
      await this.axios
        .post("Usuario/ObtenerUsuarioSesion")
        .then((response) => {
          this.respuesta = response.data;
          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            this.usuario = this.respuesta.resultado;
          } else {
            this.notificar({
              Estatus: this.respuesta.estatusRespuesta,
              Mensaje: this.respuesta.mensaje,
            });
          }
        })
        .catch((error) => {
          this.notificar({
            Estatus: this.estatusRespuesta.ERROR,
            Mensaje:
              error == "Error: Network Error" ? "Error de conexión" : error,
          });
        });
    },
    async ObtenerCatalogoCondicionantes() {
      await this.axios
        .get(`VotacionComiteCredito/ObtenerCatalogoCondicionantes`)
        .then((response) => {
          this.respuesta = response.data;
          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            this.catalogoCondicionantes = this.respuesta.resultado;
          } else {
            this.notificar({
              Estatus: this.respuesta.estatusRespuesta,
              Mensaje: this.respuesta.mensaje,
            });
          }
        })
        .catch((error) => {
          this.notificar({
            Estatus: this.estatusRespuesta.ERROR,
            Mensaje: this.obtenerMensajeError(error),
          });
        })
        .finally(() => (this.cargando = false));
    },
    async verResolucion() {
      const id = this.$route.params.id;
      await this.axios
        .get(`VotacionComiteCredito/${id}`)
        .then((response) => {
          this.respuesta = response.data;
          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            //Si la operación se encuentra en cualquier otro estatus que no sea en resolución, deshabilitar botón guardar e inputs
            var panelResolucion = document.querySelector("#panelResolucion");
            bootstrap.Modal.getOrCreateInstance(panelResolucion).show();
            this.resultadoVotaciones = this.respuesta.resultado;
          } else {
            this.notificar({
              Estatus: this.respuesta.estatusRespuesta,
              Mensaje: this.respuesta.mensaje,
            });
          }
        })
        .catch((error) => {
          this.notificar({
            Estatus: this.estatusRespuesta.ERROR,
            Mensaje: this.obtenerMensajeError(error),
          });
        })
        .finally(() => (this.cargando = false));
    },
    async validarExistenciaVoto() {
      var params = {};
      params.OperacionId = this.$route.params.id;
      await this.axios
        .post("VotacionComiteCredito/ExisteVoto", params)
        .then((response) => {
          this.respuesta = response.data;
          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            if (this.votoDto == null) this.votoDto = {};
            else this.votoDto = this.respuesta.resultado;
          } else {
            this.notificar({
              Estatus: this.respuesta.estatusRespuesta,
              Mensaje: this.respuesta.mensaje,
            });
          }
        })
        .catch((error) => {
          this.notificar({
            Estatus: this.estatusRespuesta.ERROR,
            Mensaje:
              error == "Error: Network Error" ? "Error de conexión" : error,
          });
        });
    },
    async ActualizarCandadoQuorum() {
      let operacionId = this.$route.params.id;
      await this.axios
        .post("VotacionComiteCredito/ActualizarCandadoQuorum", null, {
          params: { operacionId },
        })
        .then((response) => {
          this.respuesta = response.data;
          if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
            this.operacion.candadoQuorum = this.respuesta.resultado;
          }
          this.notificar({
            Estatus: this.respuesta.estatusRespuesta,
            Mensaje: this.respuesta.mensaje,
          });
        })
        .catch((error) => {
          this.notificar({
            Estatus: this.estatusRespuesta.ERROR,
            Mensaje: this.obtenerMensajeError(error),
          });
        })
        .finally(() => (this.cargando = false));
    },
  },
  watch: {
    votoDto: function(newVal, oldVal) {
      if (newVal != null) {
        this.voto = newVal.voto;
        if (this.voto != null) {
          var modalVotoEmitido = document.querySelector("#modalVotoEmitido");
          bootstrap.Modal.getOrCreateInstance(modalVotoEmitido).show();
        } else {
          var modalVotacion = document.querySelector("#votacion");
          bootstrap.Modal.getOrCreateInstance(modalVotacion).show();
        }
      } else {
        var modalVotacion = document.querySelector("#votacion");
        bootstrap.Modal.getOrCreateInstance(modalVotacion).show();
      }
    },
  },
});
</script>

<style scoped>
h5 {
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #4d4f5c;
}

.iconoE {
  font-size: 30px !important;
}

.texto,
p,
span {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;

  color: #302d74;
}

img {
  width: 35px;
  height: 35px;
}

.tarjeta {
  min-height: 280px;
}

.gris {
  background-color: #c4c4c4;
  color: white;
}
.gris:hover {
  color: white;
}
</style>
